<template>
    <v-dialog v-model="dialog" width="510px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon class="mx-2" color="secondary">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>delete</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                Do you really want to delete the advanced features needs of the segment <span class="secondary--text">{{ this.af.segment.name }}</span> ?
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    No
                </v-btn>
                <v-btn color="error" text class="text-capitalize" :disabled="Boolean(error)"
                    @click="deleteAF">
                    Yes</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-xs-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'

export default {
    name: 'Delete_HiddenNeeds',
    props: ['af'],
    data() {
        return {
            dialog: false,
            error: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        async deleteAF() {
            if (this.af && this.af.id) {
                const id = this.af.id
                try {
                    await this.$store.dispatch('deleteAF', id);
                }
                catch (error) {
                    console.log(error.message)
                }
            }
        }
    },
    components: { Loader }
}
</script>